import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';

export const CTASection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section className="py-24 md:py-32 bg-[#050505] relative overflow-hidden" data-testid="cta-section">
      {/* Background Glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#D4AF37]/5 rounded-full blur-[120px]" />
      </div>

      <div className="container-custom relative z-10">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="glass p-12 md:p-20 rounded-3xl text-center max-w-4xl mx-auto"
        >
          <span className="overline mb-6 block">Rejoignez-nous</span>
          <h2 className="text-3xl md:text-5xl font-medium mb-6">
            Devenez acteur du
            <br />
            <span className="text-gradient">changement par l'image</span>
          </h2>
          <p className="text-[#a1a1aa] text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            Votre soutien permet l'achat de droits de diffusion et la projection 
            d'œuvres porteuses de sens auprès de publics qui n'y ont pas accès. 
            Ensemble, faisons du cinéma un vecteur de transformation sociale.
          </p>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
            className="inline-block"
          >
            <Link
              to="/faire-un-don"
              className="btn-primary inline-block animate-glow"
              data-testid="cta-donate-btn"
            >
              Faire un don maintenant
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
